import { calculateCartData } from "@/utils/helper"

import {
  CALL_SUPPORT_PHONE_NUMBER,
  HELP_SUPPORT,
  ORDER_SUMMARY,
} from "@/components/cart/analytics/constants"

export const addAnalyticsEditCart = (cartPage, cartObj) => {
  const eventInfo = {
    eventAction: "checkout:edit cart",
    eventName: "checkout:edit cart",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit cart",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "cart:landing page:order summary",
    internalLinkURL: cartPage,
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, cartObj)
}
export const addAnalyticsCallSupportCheckout = (
  type,
  contactNumber,
  cartObj
) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${type}:${ORDER_SUMMARY}:${CALL_SUPPORT_PHONE_NUMBER}`,
    eventMsg: "n/a",
    eventName: `${type}:${ORDER_SUMMARY}:${CALL_SUPPORT_PHONE_NUMBER}`,
    eventStatus: "n/a",
    eventType: `${HELP_SUPPORT}`,
    internalLinkName: contactNumber,
    internalLinkPosition: type,
    internalLinkType: `${type}:navigation`,
    internalLinkURL: `tel:${contactNumber}`,
    internalLinkZoneName: `${type}:${ORDER_SUMMARY}`,
  }
  pushAnalyticsObjToDataLayer(eventInfo, cartObj)
}
export const continueCheckoutEventInfo = (checkoutUrl, cartObj) => {
  const eventInfo = {
    eventAction: "cart:landing page:checkout",
    eventName: "cart:landing page:checkout",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "checkout",
    internalLinkPosition: "cart",
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:landing page:order summary",
    internalLinkURL: checkoutUrl
      ? (checkoutUrl.indexOf("http") === -1 ? window.location.origin : "") +
        checkoutUrl
      : "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, cartObj)
}

export const addAnalyticsAccordianClickPromocode = (title = "", cartObj) => {
  const eventInfo = {
    eventAction: `cart:landing page:promocode ${title}`,
    eventName: `cart:landing page:promocode ${title}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: title,
    internalLinkPosition: "cart preview",
    internalLinkType: "cart:promo code",
    internalLinkZoneName: "cart:landing page:order summary",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, cartObj)
}

export const addAnalyticsClickContinueShopping = (baseUrl = "") => {
  const eventInfo = {
    eventAction: "cart:landing page: continue shopping",
    eventName: "cart: landing page: continue shopping",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "continue shopping",
    internalLinkPosition: "cart",
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:landing page",
    internalLinkURL: window.location.origin + baseUrl,
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsClickSignIn = () => {
  const eventInfo = {
    eventAction: "cart:landing page: sign in",
    eventName: "cart: landing page: sign in",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "sign in",
    internalLinkPosition: "cart",
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:landing page",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsCollabrativeCart = (title = "", cartObj) => {
  const eventInfo = {
    eventAction: `cart:landing page:${title}`,
    eventName: `cart:landing page:${title}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: title,
    internalLinkPosition: "cart",
    internalLinkType: "cart:look up a cart",
    internalLinkZoneName: "cart:landing page:order summary",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, cartObj)
}

const pushAnalyticsObjToDataLayer = async (eventInfo = {}, cartObj) => {
  const event = "cmp:click"
  const page = window.pageObj || {}

  if (cartObj) {
    const cartData = await calculateCartData({ cart: cartObj }, true)
    page.cart = cartData.cart
  }

  if (page?.cartInfo?.cartItems === "") {
    page.cart.item = []
    if (page.productInfo) {
      delete page.productInfo
    }
  }

  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
  })
}

export const addAnalyticsAuthLinks = (cartObj, linkName) => {
  const eventInfo = {
    eventAction: "cart:landing page:" + linkName,
    eventName: "cart:landing page:" + linkName,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: linkName,
    internalLinkPosition: "cart",
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:landing page:order summary",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, cartObj)
}
